import React, { forwardRef } from 'react';
import type { ForwardedRef, VideoHTMLAttributes } from 'react';

import { DataAttributes } from './types';

// This component exists because `<video>` is very hard to mock in unit tests.

export type Props = VideoHTMLAttributes<HTMLVideoElement> & DataAttributes;

const Video = forwardRef((props: Props, ref: ForwardedRef<HTMLVideoElement>) =>
// eslint-disable-next-line jsx-a11y/media-has-caption -- The children prop decides that.
  <video {...props} ref={ref} />);
Video.displayName = 'Video'; // forwardRef does not carry the display name

export default Video;
